import { useState } from 'react'
import { HelpCircle } from 'lucide-react'
import { modKey } from '@/lib/platform'

/**
 * Small ? button rendered next to the Send button. Click toggles a popover
 * listing the composer keyboard shortcuts.
 */
export function ShortcutHelpPopover() {
  const [open, setOpen] = useState(false)

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Keyboard shortcuts"
        onClick={() => setOpen(o => !o)}
        onBlur={() => setOpen(false)}
        className="size-7 inline-flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted cursor-pointer"
      >
        <HelpCircle className="size-4" />
      </button>

      {open && (
        <div className="absolute bottom-full right-0 mb-2 w-72 bg-card border border-border rounded-lg shadow-xl z-30 p-3">
          <div className="text-xs font-medium text-muted-foreground mb-2">Composer shortcuts</div>
          <ul className="space-y-1.5 text-sm">
            <Row label="Send" keys={["↵"]} />
            <Row label="New line" keys={["⇧", "↵"]} />
            <Row label="Insert chip 1-9" keys={[modKey, "1-9"]} />
            <Row label="Open emoji" keys={[":"]} hint="then type, ↵ to insert" />
            <Row label="Open GIF picker" keys={["/gif"]} hint="then type to search Giphy" />
            <Row label="Next placeholder" keys={["Tab"]} />
          </ul>
        </div>
      )}
    </div>
  )
}

function Row({ label, keys, hint }: { label: string; keys: string[]; hint?: string }) {
  return (
    <li className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <div>{label}</div>
        {hint && <div className="text-[11px] text-muted-foreground/80">{hint}</div>}
      </div>
      <div className="flex items-center gap-1 shrink-0">
        {keys.map((k, i) => (
          <kbd key={i} className="px-1.5 py-0.5 rounded bg-black/40 text-foreground border border-white/15 text-[10px] font-mono">
            {k}
          </kbd>
        ))}
      </div>
    </li>
  )
}
